import React from 'react';
import Section from 'components/common/Section';
import IconGroup from 'components/common/icon/IconGroup';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { menuList1 } from 'data/footer';
import { bgWhiteIcons } from 'data/socialIcons';
import PropTypes from 'prop-types';

const FooterTitle = ({ children }) => (
  <h5 className="text-uppercase text-white opacity-85 mb-3">{children}</h5>
);

FooterTitle.propTypes = { children: PropTypes.node };

const FooterList = ({ list }) => (
  <ul className="list-unstyled">
    {list.map(({ title, to }, index) => (
      <li className="mb-1" key={index}>
        <Link className="text-600" to={to}>
          {title}
        </Link>
      </li>
    ))}
  </ul>
);

FooterList.propTypes = { list: PropTypes.any };

const FooterStandard = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };
  return (
    <>
      <Section bg="dark" className="pt-8 pb-4 light">
        <div
          className="position-absolute btn-back-to-top cursor-pointer bg-dark"
          onClick={scrollToTop}
        >
          <FontAwesomeIcon
            icon="chevron-up"
            transform="rotate-45"
            className="text-600"
          />
        </div>
        <Row>
          <Col lg={4}>
            <FooterTitle>
              <img
                src={'/gegeenSoft.png'}
                alt="logo"
                width={40}
                height={35}
                className="me-2"
              />
              GegeeWeb
            </FooterTitle>
            <p className="text-600 ">
              GegeeWeb сайт бүтээгч платформ нь аж ахуйн нэгжийн түвшний дэд
              бүтэц, бизнесийн онцлог, дэвшилтэт SEO, маркетингийн хэрэгсэл юм.
            </p>
            <p className="mb-0">Холбоо барих : 99120224, 99134731 </p>
            <p>Имайл:support@gegeensoft.com</p>
            <IconGroup className="mt-4" icons={bgWhiteIcons} />
          </Col>
          <Col className="ps-lg-6 ps-xl-8">
            <Row className="mt-5 mt-lg-0">
              <Col xs={6} md={3}></Col>
              <Col xs={6} md={3}></Col>
              <Col className="mt-5 mt-md-0">
                <FooterTitle>Бидний тухай</FooterTitle>
                <FooterList list={menuList1} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Section>

      <section className=" bg-dark py-0 text-center fs--1 light">
        <hr className="my-0 border-600 opacity-25" />
        <div className="container py-3">
          <Row className="justify-content-between">
            <Col xs={12} sm="auto">
              <p className="mb-0 text-600">
                ©2023 БҮХ ЭРХ ХУУЛИАР ХАМГААЛАГДСАН.
                <span className="d-none d-sm-inline-block"> | </span>
                <a
                  className="text-white opacity-85"
                  href="https://themewagon.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Gegeesoft LLC
                </a>
              </p>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
};

FooterStandard.propTypes = { children: PropTypes.node };

export default FooterStandard;
